export default __webpack_public_path__ + "static/media/summer.0433b9c6.png";